/*       */

import { gql } from '@apollo/client';
import entitiesListRisedCommonQuery from 'graphql/entities/common/entitiesListRisedCommonQuery';

export default gql`
    query organisationsListRisedQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "organisation", filterBy: $filterBy, excludeBy: $excludeBy)
        records: organisations(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListRisedCommonQuery}
        }
    }
`;
